import React from 'react';

// Musteribul logosu (public/logo.svg ile aynı çizim; satır içi olduğu için ek istek yapmaz)
function Logo({ size = 36, className = '' }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 512 512"
      role="img"
      aria-label="Musteribul"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="mb-logo-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3fa9f5" />
          <stop offset="1" stopColor="#1f5fbf" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="112" fill="url(#mb-logo-bg)" />
      <path d="M256 448C256 448 128 312 128 216a128 128 0 0 1 256 0c0 96-128 232-128 232z" fill="#ffffff" />
      <circle cx="256" cy="216" r="70" fill="#1f5fbf" />
      <circle cx="256" cy="216" r="40" fill="#ffffff" />
      <circle cx="256" cy="216" r="18" fill="#1f5fbf" />
    </svg>
  );
}

export default Logo;
